import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function VersionSelect({ label, value, versions, onChange, testId, tone }) {
  const latest = versions[0]?.version;
  return (
    <div className="space-y-1 min-w-0">
      <div className={`text-[11px] font-semibold uppercase tracking-wider ${tone}`}>{label}</div>
      <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
        <SelectTrigger className="focus:ring-orange-500 h-8 text-xs" data-testid={testId}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {versions.map((v) => (
            <SelectItem key={v.id} value={String(v.version)} data-testid={`${testId}-option-${v.version}`}>
              v{v.version}{v.version === latest ? " (actual)" : ""} · {v.change_note || "Sin nota"}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
